import { AccessTime, ArrowForwardIos, ContentCopy, Delete } from "@mui/icons-material";
import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  return (
    <div
      style={{
        backgroundColor: "#FFF7ED",
        padding: "16px",
        borderRadius: "12px",
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
        border: '2px solid rgba(234, 88, 12, 0.3)',
        minWidth: "220px",
        transition: "all 0.2s ease",
        position: "relative"
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "linear-gradient(45deg, #ea580c, #c2410c)",
          width: "20px",
          height: "20px",
          top: "50%",
          left: "-10px",
          cursor: 'pointer',
          border: "2px solid #ffffff",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}
        onConnect={params => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffffff",
            width: "12px",
            height: "12px",
            marginLeft: "2px",
            marginBottom: "1px",
            pointerEvents: 'none',
            transform: "rotate(180deg)"
          }}
        />
      </Handle>

      <div
        style={{
          position: "absolute",
          right: "12px",
          top: "12px",
          display: "flex",
          gap: "8px"
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ 
            width: "18px", 
            height: "18px", 
            color: "#94a3b8",
            cursor: "pointer",
            transition: "color 0.2s ease",
            "&:hover": {
              color: "#ea580c"
            }
          }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ 
            width: "18px", 
            height: "18px", 
            color: "#94a3b8",
            cursor: "pointer",
            transition: "color 0.2s ease",
            "&:hover": {
              color: "#ef4444"
            }
          }}
        />
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "12px"
        }}
      >
        <AccessTime
          sx={{
            width: "20px",
            height: "20px",
            marginRight: "8px",
            color: "#ea580c"
          }}
        />
        <div style={{ 
          color: "#1a1a1a", 
          fontSize: "16px",
          fontWeight: "600",
          letterSpacing: "0.01em"
        }}>
          Intervalo
        </div>
      </div>

      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#ffedd5",
        borderRadius: "6px",
        padding: "12px",
        border: "1px solid #fed7aa"
      }}>
        <div style={{ 
          color: "#9a3412", 
          fontSize: "24px",
          fontWeight: "600"
        }}>
          {data.sec}
          <span style={{ 
            fontSize: "14px",
            marginLeft: "4px",
            fontWeight: "normal",
            opacity: 0.8
          }}>
            segundos
          </span>
        </div>
      </div>

      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "linear-gradient(45deg, #ea580c, #c2410c)",
          width: "20px",
          height: "20px",
          top: "50%",
          right: "-10px",
          cursor: 'pointer',
          border: "2px solid #ffffff",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffffff",
            width: "12px",
            height: "12px",
            marginLeft: "2px",
            marginBottom: "1px",
            pointerEvents: 'none'
          }}
        />
      </Handle>
    </div>
  );
});